import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";

const SEO = ({
  title = "High Converting Landing Page",
  titleTemplate = "Build High Converting Landing Pages",
  description =
    "Build high converting landing pages designed to maximize engagement, generate quality leads, and drive real business growth. Our modern React-based landing pages are optimized for fast performance, clean architecture, and seamless user experience across all devices. We focus on mobile-first design, intuitive layouts, and conversion-focused sections such as hero banners, feature highlights, step-by-step workflows, trust signals, and transparent pricing. Each landing page is crafted with SEO best practices including clean URLs, proper meta structure, canonical tags, and optimized content to help improve search engine visibility. Whether you are launching a product, promoting a service, or growing an online business, our React landing pages provide scalability, flexibility, and long-term maintainability. With modern UI, responsive design, and performance optimization at the core, these landing pages help brands build trust, increase click-through rates, and convert visitors into customers efficiently.",
  keywords =
    "landing page, seo friendly landing page, high converting landing page, website development, modern landing page design, fast website, business landing page",
  canonical,
  noindex = false,
}) => {
  const canonicalUrl =
    canonical || window.location.origin + window.location.pathname;

  const fullTitle = `${title} | ${titleTemplate}`;

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      <meta
        name="robots"
        content={noindex ? "noindex, nofollow" : "index, follow"}
      />

      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={titleTemplate} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />

      <meta name="theme-color" content="#0f172a" />
    </Helmet>
  );
};

SEO.propTypes = {
  title: PropTypes.string,
  titleTemplate: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  canonical: PropTypes.string,
  noindex: PropTypes.bool,
  ogImage: PropTypes.string
};

export default SEO;
